/* eslint-disable ember/no-computed-properties-in-native-classes, ember/no-runloop */
import InputLabel from '@linc-technologies/linced-common/components/input-label';
import { computed } from '@ember/object';
import { cancel, next } from '@ember/runloop';
import { isPresent } from '@ember/utils';

export default class ChipsLabel extends InputLabel {
  content = null;

  // `hasValueOverride` lets callers override the computed default; Ember < 4
  // allowed that implicitly (computed-property.override).
  hasValueOverride = null;

  @computed('content.length', 'hasValueOverride')
  get hasValue() {
    if (this.hasValueOverride !== null) {
      return this.hasValueOverride;
    }

    return isPresent(this.content);
  }

  focusOutTimer = null;

  focusOut() {
    if (isPresent(this.focusOutTimer)) {
      cancel(this.focusOutTimer);
    }
    this.focusOutTimer = next(this, super.focusOut);
  }

  focusIn() {
    if (isPresent(this.focusOutTimer)) {
      cancel(this.focusOutTimer);
    }
    next(this, super.focusIn);
  }
}
